import { ColumnHeaderRowType } from "components/atoms/ExpandedRowTable/ExpandedRowTable";

export const ACCOUNT_MANAGEMENT_COLUMN_DATA: Array<ColumnHeaderRowType> = [
	{
		title: "Date & Time Created",
		dataIndex: "created_on",
		align: "left",
		width: "14%"
	},
	{
		title: "Tenant Name",
		dataIndex: "tenant_name",
		align: "left"
	},
	{
		title: "Username",
		dataIndex: "username",
		align: "left"
	},
	{
		title: "Email Address",
		dataIndex: "email",
		align: "left"
	},
	{
		title: "Status",
		dataIndex: "active",
		align: "left",
		width: "10%"
	},
	{
		title: "View/Edit",
		dataIndex: "viewOrEdit",
		align: "center",
		width: "8%"
	}
];
